import { Component, OnInit } from '@angular/core';
import { AppDataService, ConfigService } from 'app/services';

export enum PartnerMartInventoryMenuEnum {
    AllProducts = 1,
    Categories = 2,
    Bundles = 3
}

@Component({
    selector: 'partner-inventory-root',
    templateUrl: './partner-inventory-root.component.html',
    styleUrls: ['./partner-inventory-root.component.scss']
})
export class PartnerInventoryRootComponent implements OnInit {
    public partnerMartInventoryMenuEnum = PartnerMartInventoryMenuEnum;
    public activePartnerMartInventoryMenu: PartnerMartInventoryMenuEnum = PartnerMartInventoryMenuEnum.AllProducts;

    constructor(private appData: AppDataService, public configService: ConfigService) {    }

    ngOnInit() {
    }

    public onMenuClick(menuLink: PartnerMartInventoryMenuEnum) {
        this.activePartnerMartInventoryMenu = menuLink;
    }
}
